import { render, staticRenderFns } from "./EditCategoryModal.vue?vue&type=template&id=2b33b8b7&"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports